import type { Region } from '@lt/api/dist/methods/references/types';
import type { HotelId } from '@lt/api/dist/types/hotels';
import { formatCurrency } from 'src/utils/stringUtils';

import type { Hotel } from '../../components/Hotels/types';

interface geoHotelPointProps {
  hotelInfo: Hotel;
  viewedHotels: HotelId[];
}

export const hotelGeoPoint = ({
  hotelInfo,
  viewedHotels,
}: geoHotelPointProps) => {
  const { hotel, min_price } = hotelInfo;
  const isViewedHotels = viewedHotels.includes(Number(hotel.id));

  return {
    type: 'Feature',
    properties: {
      id: hotel.id,
      state: 'active',
      visited: isViewedHotels,
      price: min_price,
      rating: hotel.rating || 0,
      // дублируем координаты, для отображения попапа
      coordinates: [hotel.long, hotel.lat],
    },
    geometry: {
      type: 'Point',
      coordinates: [hotel.long, hotel.lat],
    },
  };
};

export const regionGeoPoint = (region: Region) => ({
  type: 'Feature',
  properties: {
    kind: 'City',
    ancestry_depth: 4,
    name: region.name,
    price_range: region.price ? formatCurrency(region.price) : '',
    // дублируем координаты, чтобы иметь к ним доступ
    coordinates: region.coordinates,
  },
  geometry: {
    type: 'Point',
    coordinates: region.coordinates,
  },
});
